
import React, { useEffect, useState } from 'react'
import AlertBox from './AlertBox';
import UsersBox from './UsersBox';
import ProgramBox from './ProgramBox';
import ErrorBoundary from '../../ErrorBoundary';
import { useNavigate } from 'react-router-dom';

function Home() {
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));
const navigate = useNavigate();
const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

if(!userInfo){
    navigate('/prelogin');
    return false;
  }
  return (
    <>
        <div style={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between',
        gap: '1rem',
        width: '100%',
      }}>
            <ErrorBoundary>
              <ProgramBox />
            </ErrorBoundary> 
            <ErrorBoundary>
              <AlertBox /> 
            </ErrorBoundary>  
        </div>
        <ErrorBoundary>
          <UsersBox/>
        </ErrorBoundary>
    </>
  )
}

export default Home